import React from 'react';
import ReactDOM from 'react-dom';
import { RootState } from '@/store';
import { selectModals, systemActions } from '@/store/features';
import { Dialog, Transition } from '@headlessui/react';
import { connect, useDispatch } from 'react-redux';

interface ModalProps extends React.PropsWithChildren {
  id: string;
  className?: string;
  modals: string[];
  containerCls?: string;
  onClose?: () => void;
}

function Modal({
  id,
  children,
  className,
  modals,
  containerCls,
  onClose = () => null,
}: ModalProps) {
  const dispatch = useDispatch();
  const { hideModal } = systemActions;

  return ReactDOM.createPortal(
    <Transition.Root show={modals && modals[modals.length - 1] === id} as={React.Fragment}>
      <Dialog
        as='div'
        className='relative z-10'
        onClose={() => {
          dispatch(hideModal());
          onClose();
        }}
      >
        <Transition.Child
          as={React.Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 z-10 bg-black bg-opacity-75 transition-opacity' />
        </Transition.Child>
        <div className='fixed inset-0 z-20 overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center px-4 text-center sm:items-center sm:p-0'>
            <Transition.Child
              as={React.Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
              enterTo='opacity-100 translate-y-0 sm:scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 translate-y-0 sm:scale-100'
              leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
            >
              <Dialog.Panel
                className={`p-4 sm:p-6 sm:w-fit w-full sm:max-w-full  relative transform overflow-hidden rounded-lg bg-white dark:bg-[#242424] dark:text-white text-left shadow-xl transition-all  ${className}`}
              >
                <div className={containerCls}>{children}</div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>,
    document.body,
  );
}

export default connect((state: RootState) => ({
  modals: selectModals(state),
}))(Modal);
